import { NgModule } from '@angular/core';
import { RippleDirective } from './ripple.directive';

@NgModule({
    declarations: [
        RippleDirective
    ],
    imports: [],
    exports: [
        RippleDirective
    ]
})
export class NcRippleModule { }